/* tslint:disable:no-trailing-whitespace import-spacing no-inferrable-types typedef-whitespace variable-name align */

import {ProjectElement}          from './project.element';
import {ProjectElementType}      from './project.element.type';
import { ProjectElementFactory } from '../project.element.factory';

import { Project }               from '../project';

import { BlobType }              from '../blob';
import { Logger }                from '@/util/logger';

import {ActionType} from "@/models/action";
import {ProjectElementFactoryDecorator} from "@/models/project/project.element.factory.decorator";
import {ActionService} from "@/services/action.service";
import {ServiceLocator} from "@/services/service.locator";
import {FileBrowserMetadata} from "@/screens/ide/file.browser.metadata";

/**
 *
 * @class CorridorGroupElement
 *
 * @brief grouping element for corridors of operational measures section
 *
 * - - - - - - - - - - - - - - - - - - -
 * @author    Michael Garvin (mike.garvin@ironroad.ca)
 * @date      February 2022
 *
 */
@ProjectElementFactoryDecorator('CorridorGroupElement')
export class CorridorGroupElement extends ProjectElement {

  public actionKeys: string[] = [
    'deletecorridor',
    'generatekpitable',
    'viewinbrowser'
  ];

  /** standard constructor */
  constructor(
    project: Project,
         id: string,
       name: string,
     parent: ProjectElement,
    publish?: boolean
  ) {

    super(project, id, ProjectElementType.CorridorGroup);

    this._acceptsBlobs.push(BlobType.None);

    this._enabled     = true;
    this._label       = name;
    this._icon        = 'fa fa-th-list';
    this._elementKind = 'Corridor Group';

    if (parent) {

      this._project.addElement(this, parent, publish);

    }

  }

  /** helper to use to for static global constructors (and factory registration) */
  static requireType() {
    console.log("requiring CorridorGroupElement");
  }

  /**
   * sub-classes must add their menu item definition(s) to the given action set,
   * in jquery-contextmenu fashion.
   *
   * @param actionSet any
   *
   */
  public actions(actionSet: any): any {

    actionSet.generatekpitable = {
      name: 'Generate KPI Table',
      icon: 'far fa-chart-bar',
      disabled:  this.isBusy()
    };

    actionSet.viewinbrowser = {
      name: 'Folder Of',
      icon: 'fas fa-list',
      disabled: false
    };

    actionSet.deletecorridor = {
      name: 'Delete Corridor',
      icon: 'fas fa-trash-alt',
      disabled:  this.isBusy()
    };

    return actionSet;
  }

  /** is this element deletable? */
  public isDeletable() : boolean {

    return !this.isBusy();
  }

  /** test if this element accepts the given action */
  public acceptsAction(key: string): boolean {

    return !!this.actionKeys.find(x => x === key);
  }

  /** subclasses must implement their own actions */
  public action(key: string, selection: ProjectElement[]) {

    switch (key) {

      case 'generatekpitable': {

        Logger.debug('[CorridorGroupElement] generatekpitable');

        this._project.generateKPITable(this);
      }
      break;

      case 'viewinbrowser': {

        this._project.services.ide.launchWindow(FileBrowserMetadata.build(this._blobKey, this._blobKey));

        break;
      }

      case 'deletecorridor': {

        Logger.debug('[CorridorGroupElement] deletecorridor');

        this.deleteElements(selection);

      }
      break;
    }
  }




}
